import React from 'react';
import { Redirect } from 'react-router-dom';

import { PasswordResetTemplate } from '../components/common/template/PasswordResetTemplate';
import { usePasswordReset } from '../Hooks/usePasswordReset';
import { SIGNIN } from '../lib/routes/path';

const PasswordResetPage = ({ match }) => {
  const { code } = match.params;
  const {
    state: { check, confirmPassword, password, toSignIn },
    onChange,
    onSubmit,
  } = usePasswordReset(code);

  return toSignIn ? (
    <Redirect to={SIGNIN} />
  ) : (
    <PasswordResetTemplate
      check={check}
      state={{ confirmPassword, password }}
      onChangeValue={onChange}
      onSubmit={onSubmit}
    />
  );
};

export default PasswordResetPage;
